import { PropsWithChildren } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

import { slugify } from "@covertree/utils";
import { Button } from "@covertree/ui";

interface SummaryBoxProps {
  title: string;
  navigate: () => void;
}

export function SummaryBox({
  title,
  navigate,
  children,
}: PropsWithChildren<SummaryBoxProps>) {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  return (
    <Box
      border={(theme) => `1px solid ${theme.colors.grey3}`}
      borderRadius={2}
      p={3}
      mb={3}>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Typography
            variant={isDesktop ? "h4" : "h5"}
            sx={(theme) => ({
              [theme.breakpoints.down("md")]: {
                lineHeight: "1.4",
              },
            })}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="outlined"
              size="small"
              onClick={navigate}
              data-testid={`${slugify(title)}-edit-btn`}>
              Edit
            </Button>
          </Box>
        </Grid>
        {children}
      </Grid>
    </Box>
  );
}
